
// Get category popularity data
export const getCategoryPopularity = (categories: any[], filteredOrders: any[]) => {
  if (!filteredOrders?.length) {
    return [];
  }

  const categoryData: Record<string, { count: number, revenue: number }> = {};
  
  // Calculate orders and revenue by category (using product_id since that's what we have)
  filteredOrders.forEach(order => {
    if (!order?.product_id) {
      return; // Skip orders without product assignment
    }

    const product = categories?.find(c => c.id === order.product_id);
    const categoryName = product?.name || "Unknown Product";
    
    if (!categoryData[categoryName]) {
      categoryData[categoryName] = { count: 0, revenue: 0 };
    }
    
    categoryData[categoryName].count += 1;
    const amount = parseFloat(order.total_amount) || 0;
    categoryData[categoryName].revenue += amount;
  });
  
  // Convert to array of objects for chart, only showing categories with data
  return Object.entries(categoryData)
    .map(([name, { count, revenue }]) => ({
      name,
      orders: count,
      revenue: Number(revenue.toFixed(2)),
    }))
    .filter(category => category.orders > 0)
    .sort((a, b) => b.orders - a.orders);
};
